import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import ReportIcon from "@mui/icons-material/Report";
import { useBnIdle } from "use-bn-idle";

export const IdleAlertPopUp = (props) => {
  const { show, message, onClose } = props;
  const [startTimer, stopTimer] = useBnIdle(() => {
    window.location.reload();
  });
  useEffect(() => {
    startTimer(10);
  });
  return (
    <Dialog onClose={() => onClose()} open={show}>
      <DialogTitle
        sx={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}
      >
        <ReportIcon />
        Attention
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2">{message}</Typography>
      </DialogContent>
      <DialogActions sx={{ alignItems:"right" }}>
        <Button color="primary" autoFocus onClick={onClose}>
          I'm here
        </Button>
      </DialogActions>
    </Dialog>
  );
};
